import { render, staticRenderFns } from "./DeletedShow.vue?vue&type=template&id=562b5376&"
import script from "./DeletedShow.vue?vue&type=script&lang=js&"
export * from "./DeletedShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports